<template>
  <modal>
    <template v-if="success">
      <h2 class="font-bold">Factuur betaald!</h2>
      <p>Dankjewel! We hebben je betaling ontvangen</p>
    </template>
    <template v-else>
      <h2>De betaling is niet gelukt!</h2>
      <p>Helaas, de betaling is niet gelukt, probeer het opnieuw.</p>
    </template>
  </modal>
</template>
<script lang='ts' setup>
import Modal from '@app/components/Modal.vue';

defineProps<{success: boolean}>();
</script>
